/**
 * 매직라인5 사용자 제공 JS
 * 
 * - iframe 초기화
 * - 인증서 창 호출
 * - 처리 응답 데이터 수신
 * 
 */

// JS 로딩 시 초기화 처리를 하기위한 이벤트 리스너 등록
document.addEventListener("DOMContentLoaded", () => {
    // 이미 iframe이 생성되어 있으면 제거 후 새로 생성
    if(document.getElementById("dscertContainer")){
        ML5.removeIframe();
    }
    ML5.initIframe(); // iframe 속성 값 / UI 영역 셋팅
});

/**
 * 
 * 사용자 페이지에 ML5.js 가 링크된 URL 기준으로 ml5web 경로로 사용 한다
 * 
 * - iframe 안에 삽입될 MLMain.html 경로를 계산하여 자동으로 넣기위해 사용
 * - ML5.js 스크립트 태그로 링크 시 반드시 id="ml5" 를 속성으로 추가해야 한다. 
 * 
 */
// 
/**
 * MLMain.html 로딩 시 인자 값으로 현재 사용할 날짜 값을 생성한다.
 * 
 * @returns 년월일 값 
 */
function getYYYYMMDD() {
    let currentDate = new Date();
    let yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth()+1; // getMonth() is zero-based
    let dd  = currentDate.getDate();
    return String(10000*yyyy + 100*mm + dd); // Leading zeros for mm and dd
}

/**
 * ML5.js 가 호출되는 실제 중간 경로 기준으로 ml5web 폴더 앞의 경로를 가져온다.
 * 
 * @returns ml5PathString origin과 ml5web 폴더 사이의 path string
 */
function getMainHtmlPathString(){
    let ml5PathString = ""; // origin 값을 제외한 MLMain.html 경로를 담는다
    let scriptML5Path = document.getElementById("ml5").src;
    let splitML5Path = scriptML5Path.split("/");
    // 0 - 2 까지는 프로토콜 도메인(:포트) 영역 해당 부분 이후 부터 조림하여 사용하면 됨
    // 예를들어 https://localhost/ml5web/js/ML5.js 라고 하면 0-2 는 https://localhost 이고, 나며지 값만 조립하여 사용 3-5 (뒤에 js, ML5.js는 제외, -2를 해준다)
    // 5개, 앞에 빼면 2개 남음... 뒤에 경로 -2 하면 사이에 path가 없음 -> ml5web 사이에 경로 없음 확인
    let totalPathCnt = splitML5Path.length; // '/' 로 분리한 배열의 총 갯수
    let startPathCnt = 4; // origin 값을 제외하고 이후 경로를 확인하기 위해 필요한 배열 시작 카운트
    let prePathCnt = 2; // ml5web 경로에 해당하는 부분 까지 제외하기 위한 카운트
    let preOriginUrl = splitML5Path[0] + "//" + splitML5Path[2];  //origin을 만든 값
    let middlePathCnt = totalPathCnt - startPathCnt - prePathCnt; // ml5web 폴더 까지 중간 경로 갯수
    // 중간 경로 카운트가 0보다 크면 경로 조립
    if(middlePathCnt > 0){
        let loopStartCnt = startPathCnt - 1;
        for (let i = loopStartCnt; i < loopStartCnt + middlePathCnt; i++ ){
            ml5PathString = ml5PathString + "/" + splitML5Path[i];
        }
    }
    //TODO
    //ml5PathString = splitML5Path[0] + splitML5Path[1] + splitML5Path [2] + "/" + ml5PathString + "/ml5web/MLMain.html?" + getYYYYMMDD() 
    ml5PathString = ml5PathString + "/ml5web/MLMain.html?" + getYYYYMMDD() 
    return ml5PathString;
}

/**
 * MagicLine4NX 설치 파일의 절대경로 확인 시 필요한 값
 * 
 * @returns origin과 ml5web 폴더 사이의 path string
 */
function getDownloadPath() {
    let scriptML5Path = document.getElementById("ml5").src;
    let idx = scriptML5Path.indexOf('/ml5web');
    if (idx !== -1) {
        return scriptML5Path.substring(0, idx + '/ml5web'.length);
    } else {
        // 경로를 찾지 못했을 경우
        return "";
    }
}

//세션스토리지 Key 명
const sessionKeyName = "ML5Session";

// 현재 포커스를 가진 버튼 요소를 저장할 변수
let lastFocusedElement;

// 클로저 형태로 선언하여 private 변수/함수 구분
const ML5 = (function () {
    // private 변수 선언 => return 내부에서 this. 없이 호출 가능
    // callback 을 처리할 변수
    let callback = "";
    /**
     * postMessage 고찰
     * - 보낼 곳의 origin을 명시하여 받는 쪽에서 origin 검증을 하는 것이 원칙
     * - origin 은 프로토콜, 도메인, 포트 정보까지만 포함됨, * 로 명시할 경우 origin을 모두 허용
     */
    // postMessage 를 보낼 traget origin (IE외 브라우저에서는 window.location.origin 으로 확인 가능)
    let targetOrigin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    // 설정 값 셋팅(고정)

    // 공통으로 사용되는 메시지 구조체
    const createMessage = (key = "", data = "", options = "") => ({
        sender: "ML5",
        key,
        data,
        options,
        code: 0,
        resultMsg: ""
    });

    // iframe 속성 설정 함수
    const setIframeAttributes = (iframe, config) => {
        for(let key in config){
            if(config.hasOwnProperty(key)) {
                let value = config[key];
                iframe.setAttribute(key, value);
            }
        }
    };

    // 외부로 공개할 데이터나 메서드를 프로퍼티로 추가한 객체를 반환한다.
    return {
        //사용자가 설정한 환경설정 파일 경로
        configFilePath: "",
        // 웹 관리도구에서 가져온 환경설정 JSON
        remoteConfigJSON: "",
        // origin 과 ml5web 폴더 사이 경로
        downloadPath: getDownloadPath(),
        iframeConfig: {
            id: "dscert",
            name: "dscert",
            title: "dscert",
            src: getMainHtmlPathString(),
            scrolling: "no",
            width: "100%",
            height: "100%",
            frameBorder: "0",
            allowTransparency: "true",
            translate: "yes",
            style: "position:fixed; z-index:100010; top:0px; left:0px; width:100%; height:100%;"
        },
        // iframe 내부로 postMessage 요청을 보내기 위한 메세지 구조체 -> !!!! sender 는 ML5에서 Message Event로 주고 받는 메세지임을 확인하기 위한 값
        requestMessage: createMessage(),
        /**
         * 이벤트 리스너에 message 이벤트와 callback 처리 할 함수를 등록
         * @param {function} callback 응답결과
         */
        addEventListener(callback) {
            if (window.addEventListener) {
                window.addEventListener("message", this.eventHandler, false);
            } else if (window.attachEvent) {
                window.attachEvent("onmessage", this.eventHandler);
            }
        },
        /**
         * 이벤트 데이터 값을 체크 하여 해당 처리를 한다.
         * 
         * @param {object} event 감지된 이벤트 객체 
         * @returns callback 메세지
         */
        eventHandler(event) {
            if (event.origin !== targetOrigin) return; // postMessage의 traget origin 검증
            let childMessage = event.data;
            // ML5 Message 확인(다른 외부 어플리케에션에서 Mesaage 이벤트가 발생할 경우 방어)
            if (childMessage == null || childMessage.sender !== "ML5") return;

            if(childMessage.key === 'showContainer'){
                document.getElementById("dscertContainer").style.display = "block";
                // 인증서 창 가운데 정렬을 위한 함수 호출
                let options = "centerLayout"
                let sendMessage = ML5.makeRequestMessage("", "", options);
                ML5.sendToChildPostMessage(sendMessage, callback);
            }else if(childMessage.key === 'closeModal'){
                document.getElementById("dscertContainer").style.display = "none";
                if(lastFocusedElement !== undefined) document.getElementById(lastFocusedElement).focus();
                // 인증서창 닫힘 여부를 확인하기 위해 callback을 한다.(웹 접근성 대응, 필요한 경우 주석 제거 후 사용 - 사용자는 code 처리 추가 필요)
                let closeCallbackCode = "cancel"; // 닫기 결과코드는 "cancel"으로 응답한다. (기능 처리 성공은 0)
                let closeCallbackMessage = "인증서 창 닫힘";
                if(typeof(callback) === "function"){
                    callback(closeCallbackCode, closeCallbackMessage);
                }else{
                    console.error(closeCallbackCode + ": " + closeCallbackMessage);
                }
            }else{
                document.getElementById("dscertContainer").style.display = "none";
                if(typeof(callback) === "function"){
                    callback(childMessage.code, childMessage);
                }else{
                    console.error(childMessage.code + ": " + childMessage.resultMsg);
                }
            }
        },

        /**
         * 메인 인증서 창을 컨트롤 할 iframe 및 속성 값을 셋팅 한다.
         */
        initIframe() {
            const body = document.body;
            const div = document.createElement('div');
            const iframe = document.createElement('iframe');

            setIframeAttributes(iframe, this.iframeConfig);
            iframe.onload = function () { };

            div.id = "dscertContainer";
            div.style.display = "none";
            div.appendChild(iframe);

            if (!document.getElementById("dscertContainer")) {
                body.appendChild(div);
            }
        },
        /**
         * 사용자 지정 환경설정 파일 정보를 MLAct로 보낸다.
         * (페이지 로딩 시 호출해야 적용됨)
         * 
         * @param {string} filePath 파일경로
         */
        setConfig(filePath){
            if (filePath !== undefined && filePath !== '') {
                this.configFilePath = filePath;
            }
        },
        /**
         * 웹 관리도구에서 가져온 환경설정(JSON String) 값으로 세팅한다.
         * 
         * @param {String} Authorization    회사 정보 인가를 위한 인증 키 값
         * @param {String} clientId         지정된 회사 정보를 사용 할 수 있는 클라이언트 고유 값
         * @param {String} configId         회사 별 설정 된 환경 설정 목록의 ID 값
         * @param {String} requestUrl       API를 호출하기 위한 웹 관리도구 URL 경로
         */
        setEnv(Authorization, clientId, configId, requestUrl){
            if (Authorization == undefined || Authorization == '') {
                console.error("Authorization value is required.");
                return;
            }
            if (clientId == undefined || clientId == '') {
                console.error("clientId is required.");
                return;
            }
            if (configId == undefined || configId == '') {
                console.error("configId is required.");
                return;
            }
            if (requestUrl == undefined || requestUrl == '') {
                console.error("requestUrl is required.");
                return;
            }
            
            // 요청 처리를 위한 정보 셋팅 및 응답 값 처리
            let xhr = new XMLHttpRequest();
            // API 요청 URI 생성 - /ENV/{클라이언트 아이디}/{설정 아이디}
            let requestUri = requestUrl + "/ENV/" + clientId + "/" + configId
            xhr.open('GET', requestUri, false);
            // 요청 시 헤더에 값 셋팅 (pre flight 오류 방지를 위해 서버에 사용자 지정 헤더에 대한 허용 설정 추가)
            xhr.setRequestHeader('AuthKey', Authorization);
            xhr.onload = () => {
                try {
                    // 요청 성공 시 응답 값 처리
                    if (xhr.status === 200) {
                        const response = JSON.parse(xhr.responseText);
                        if (response.status === 0) {
                            // 지정 된 변수에 JSON 값 세팅 (MLAct.js 로딩 시 해당 값 설정 값에 overwrite)
                            this.remoteConfigJSON = JSON.parse(response.msg);
                        } else {
                            // 설정값을 가져오지 못한 경우
                            console.error('Invalid request parameters. Status:', response.status, ' msg:', response.msg);
                        }
                    } else {
                        // 요청 실패 시 에러 처리
                        console.error('Request failed. Status:', xhr.status, ' msg:', response.msg);
                    }
                } catch (e) {
                    // JSON 파싱 실패 시 에러 처리
                    console.error("JSON parse 실패:", e);
                }
            };
            // 요청 전송 (실제 body 데이터는 요청 시 없으므로 GET 방식으로 가져오도록 고려 함)
            xhr.send();
        },
        /**
         * 사용자 지정 iframe 내 html 페이지를 설정 한다.
         * (페이지 로딩 시 호출해야 적용됨)
         * 
         * @param {string} filePath 파일경로
         */
        setIframePath(filePath){
            if (filePath !== undefined && filePath !== '') {
                this.iframeConfig.src = filePath;
            }
        },
        /**
         * 기존에 존재하는 iframe 제거
         */
        removeIframe() {
            const div = document.getElementById('dscertContainer');
            if (div) {
                div.remove();
            }
        },
        /**
         * ML5 서비스 이용을 위해 인증서창 팝업을 요청
         * @param {string} signType         서명 형식 ("pkcs1", "pkcs7", "pkcs7_pdf")
         * @param {string} plainText        서명할 원문
         * @param {string} signOption       서명 시 옵션 (savesession / login)
         * @param {function} callback       응답 결과를 처리할 함수
         * @param {object} [param]          간편인증 혹은 서명관련 옵션 (직접 서명 옵션 설정 시)
         * @param {object} [param.sign]     서명관련 옵션
         * @param {string} [param.sign.ds_msg_decode]       서명관련 옵션
         * @param {string} [param.sign.ds_pki_hash]         서명관련 옵션
         * @param {string} [param.sign.ds_pki_rsa]          서명관련 옵션
         * @param {string} [param.sign.ds_pki_sign]         서명관련 옵션
         * @param {string} [param.sign.ds_pki_sign_type]    서명관련 옵션
         * @param {object} [param.ezauth]                   간편인증 관련옵션
         * @param {object} [param.ezauth.siteId]            간편인증을 사용하기 위해 간편인증 Admin 에서 등록한 사이트 Id
         * @param {object} [param.ezauth.serviceUse]        서비스 용도 ("both", "personal", "corp": 개인 및 사업자, 개인, 사업자)
         * @param {object} [param.ezauth.serviceType]       간편인증 타입 ("auth", "login", "sign": 간편인증 간편로그인 간편서명)
         * @param {object} [param.ezauth.signPKCSType]      서명 데이터 타입 ("PKCS7"만 지원)
         * @param {object} [param.ezauth.signContentType]   서명 원문 타입 ("plainText"만 지원)
         */
        open(signType, plainText, signOption, callback, param) {
            // 요청 메세지를 생성한다.
            let sendMessage;
            if (param !== undefined) {
                sendMessage = this.makeRequestMessage(signType, plainText, signOption, param);
            } else {
                sendMessage = this.makeRequestMessage(signType, plainText, signOption);
            }

            //UI 개발되면 수정 필요(iframe 내 인증서 창을 보여준다)
            document.getElementById("dscertContainer").style.display = "none";
            //  요청된 기능을 수행하기 위해 child로 해당 명령을 요청한다.
            this.sendToChildPostMessage(sendMessage, callback);
        },
        /**
         * 세션에 담긴 인증서 값으로 전자서명을 수행하고자 할 때 사용한다.
         * 
         * @param {string} signType   서명 형식 ("pkcs1", "pkcs7", "pkcs7_pdf")
         * @param {string} plainText  서명할 원문
         * @param {function} callback 응답 결과를 처리할 함수
         */
        sign(signType, plainText, callback){
            // 요청 메세지를 생성한다.
            // requestMessage.options="signsession" 설정 (전자서명 정보를 세션에 저장한 것으로 사용하는 옵션)
            let options = "signsession"
            let sendMessage = this.makeRequestMessage(signType, plainText, options);

            if(this.sessionStorage.load() !== null && this.sessionStorage.load() !== undefined && this.sessionStorage.load() !== ""){
                sendMessage.session = this.sessionStorage.load();
                //세션에 저장된 값으로 서명 요청
                this.sendToChildPostMessage(sendMessage, callback);
            }else{
                //세션에 값이 없으면 실패 응답
                sendMessage.resultMsg = "전자서명에 필요한 정보가 없습니다";
                callback(1, sendMessage); 
            }
        },
        // 요청받은 전자서명 데이터 생성 요청 메세지를 생성 한다.
        /**
         * 
         * @param {string} signType         서명 형식 ("pkcs1", "pkcs7", "pkcs7_pdf")
         * @param {string} plainText        서명할 원문
         * @param {string} signOption       서명 시 옵션 (savesession / login)
         * @param {object} [param]          간편인증 혹은 서명관련 옵션 (직접 서명 옵션 설정 시)
         * @returns {object}                전자서명 데이터 생성 요청 메세지
         */
        makeRequestMessage(signType, plainText, signOption, param) {
            const message = createMessage(signType, plainText, signOption);

            if (param) {
                if (param.sign) message.pkiinfo = param.sign;
                else if (param.ezauthHub) message.ezauthHub = param.ezauthHub;
                else if (param.ezauthBank) message.ezauthBank = param.ezauthBank;
                else if (param.makeHash) message.makeHash = param.makeHash;
                else if (param.pfxExport) message.pfxExport = param.pfxExport;
                else if (param.ucpid) message.ucpid = param.ucpid;
                else if (param.initialView) message.initialView = param.initialView;
                else if (param.shouldHashContent) message.shouldHashContent = param.shouldHashContent;
            }

            return message;
        },
        /**
         * 전자서명 데이터 생성을 위한 PKI 정보를 세션에 저장
         * @param {object} sessionInfo 저장할 정보
         */
        saveSessionInfo(sessionInfo){
            this.sessionStorage.save(sessionInfo);
        },
        /**
         * 전자서명 데이터 생성을 위한 PKI 정보를 세션에서 불러오기
         * @returns {object} PKI 정보
         */
        loadSessionInfo(){
            return this.sessionStorage.load();
        },
        /**
         * 현재 포커스를 가진 버튼 요소의 id를 저장
         * @param {String} elementId 버튼 요소의 id
         */
        setFocusAfterClosed(elementId){
            lastFocusedElement = elementId;
        },
        /**
         * 인증서 및 개인키로 pfx 인증서로 export 한다.(MagicMRS 에서 주로 사용)
         * @param {object} param 
         * @param {function} callback 
         */
        pfxExport(param, callback){
            let options = "pfxExport";
            //처리에 필요한 정보: certs - 인증서와 개인키 정보(서명용 및 암호화용 인증서와 개인키) / 인증서 비밀번호
            /* param(pfxExport) 정보
                { certs: certs, password: password }
                - certs: 서명용/암호화용 개인키 및 인증서
                    {
                        signcert: 서명용 인증서(base64 string),
                        signpri: 서명용 개인키(base64 string),  
                        kmcert: 암호화용 인증서(base64 string),
                        kmpri: 암호화용 개인키(base64 string),
                        pkcs5decrypt: 개인키 PKCS#5 decrypt 처리 여부(true/false)
                    }
                - password: 인증서 비밀번호
            */
            let sendMessage = this.makeRequestMessage("", "", options, param);
            this.sendToChildPostMessage(sendMessage, callback);
        },
        /**
         * replay attack 방지를 위한 UCPID Nonce 값을 생성한다.
         * @returns {string} UCPID Nonce 값
         */
        makeUCPIDNonce() {
            let ucpidNonce = new Array(16);
            for (var i=0; i<ucpidNonce.length; i++) 
                ucpidNonce[i] =Math.floor(Math.random() * 0x100);
            return ucpidNonce;
        },
        /**
         * UCPID RequestInfo 값을 생성한다.
         * @param {string} ucpidAgreement           개인정보제공 및 활용동의 약관 (struct)
         * @param {boolean} ucpidRealName           ISP에서 필요로 하는 개인정보 항목 - 이름
         * @param {boolean} ucpidGender             ISP에서 필요로 하는 개인정보 항목 - 성별
         * @param {boolean} ucpidNationalInfo       ISP에서 필요로 하는 개인정보 항목 - 국적
         * @param {boolean} ucpidBirthDate          ISP에서 필요로 하는 개인정보 항목 - 생년월일
         * @param {boolean} ucpidCi                 ISP에서 필요로 하는 개인정보 항목 - 주민번호(ci)
         * @param {string} ispUrlInfo               sheme 정의부와 uri 정의부를 제외한 url (문자열)
         * @param {string} ucpidNonce               랜덤값 (array)
         * @returns {object}                        UCPID RequestInfo 값
         */
        makeUCPIDRequestInfo(ucpidAgreement,ucpidRealName,ucpidGender,ucpidNationalInfo,ucpidBirthDate,ucpidCi,ispUrlInfo,ucpidNonce){
            //금융인증서 UCPID SDK 호출을 위한 값 세팅
            let ucpid = {};
            
            ucpid.userAgreeInfo = {
                ucpidRealName : ucpidRealName,
                ucpidGender : ucpidGender,
                ucpidNationalInfo : ucpidNationalInfo,
                ucpidBirthDate: ucpidBirthDate,
                ucpidCi: ucpidCi
            };

            ucpid.ucpidAgreement = ucpidAgreement;
            ucpid.ispUrlInfo = ispUrlInfo;
            ucpid.ucpidNonce = ucpidNonce;
            
            let _0x4127			= ['charAt','indexOf','39244PPzLvP','name','revision','vendorName','ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=','139183OTZlpm','join','205777nFKene','160116bceysy','18935MgzcmE','major','replace','5JOANGH','length','push','85785urBQfy','build','concat','charCodeAt','minor','fromCharCode','226829zxpEsv'];(function(_0x439d3e,_0x2736a5){var _0x22fd27=_0x581b;while(!![]){try{var _0x4f0063=parseInt(_0x22fd27(0x7e))+parseInt(_0x22fd27(0x6d))+-parseInt(_0x22fd27(0x7f))+parseInt(_0x22fd27(0x7b))+parseInt(_0x22fd27(0x82))*-parseInt(_0x22fd27(0x76))+-parseInt(_0x22fd27(0x73))+parseInt(_0x22fd27(0x7d));if(_0x4f0063===_0x2736a5)break;else _0x439d3e['push'](_0x439d3e['shift']());}catch(_0x779298){_0x439d3e['push'](_0x439d3e['shift']());}}}(_0x4127,0x2458d));function genModuleInfo(_0x483605,_0x4d7c4a){var _0x5547d7=_0x581b,_0x3a50ab=setASN1(getBytes(_0x483605[_0x5547d7(0x77)]),0xc,0x0),_0x1e3a7c=setASN1(getBytes(_0x483605[_0x5547d7(0x79)]),0xc,0x0),_0x87a40a=genModuleVersion(_0x4d7c4a),_0x463b7b=_0x3a50ab[_0x5547d7(0x6f)](_0x1e3a7c);_0x463b7b=_0x463b7b[_0x5547d7(0x6f)](_0x87a40a);var _0x5e0682=setASN1(_0x463b7b,0x30,0x0);return _0x5e0682;}function genModuleVersion(_0x5af5f3){var _0x6e0b67=_0x581b,_0x43e6d4=setASN1(int2Bytes(_0x5af5f3[_0x6e0b67(0x80)]),0x2,0x0),_0x26d27d=setASN1(int2Bytes(_0x5af5f3[_0x6e0b67(0x71)]),0x2,0x0),_0x46e947=null,_0x3b9710=null;if(_0x5af5f3['build']!=undefined){var _0xc6ab7d=setASN1(int2Bytes(_0x5af5f3[_0x6e0b67(0x6e)]),0x2,0x0);_0x46e947=setASN1(_0xc6ab7d,0xa0,0x0);}if(_0x5af5f3[_0x6e0b67(0x78)]!=undefined){var _0xc6ab7d=setASN1(int2Bytes(_0x5af5f3[_0x6e0b67(0x78)]),0x2,0x0);_0x3b9710=setASN1(_0xc6ab7d,0xa1,0x0);}var _0x551587=_0x43e6d4[_0x6e0b67(0x6f)](_0x26d27d);if(_0x46e947!=null)_0x551587=_0x551587[_0x6e0b67(0x6f)](_0x46e947);if(_0x3b9710!=null)_0x551587=_0x551587[_0x6e0b67(0x6f)](_0x3b9710);var _0x17c0fc=setASN1(_0x551587,0x30,0x0);return _0x17c0fc;}function genPersonInfoReq(_0x3d257f,_0x4b571d,_0x3e96aa,_0x2623ac,_0x15d05e,_0x50872c){var _0x5ad80a=_0x581b,_0x53c22f=0x80,_0x577b52=0x40,_0x194f32=0x20,_0x1b54cc=0x10,_0x3dbd95=0x8,_0x56a15d=new Array(0x1),_0x5d4739=0x3;_0x56a15d[0x0]=(_0x4b571d==!![]?_0x53c22f:0x0)|(_0x3e96aa==!![]?_0x577b52:0x0)|(_0x2623ac==!![]?_0x194f32:0x0)|(_0x15d05e==!![]?_0x1b54cc:0x0)|(_0x50872c==!![]?_0x3dbd95:0x0);var _0x6d4ef8=setASN1(getBytes(_0x3d257f),0xc,0x0),_0x3b57a1=setASN1(_0x56a15d,0x3,_0x5d4739),_0x125b89=_0x6d4ef8[_0x5ad80a(0x6f)](_0x3b57a1),_0x33c015=setASN1(_0x125b89,0x30,0x0);return _0x33c015;}function makeUCPIDMsg(_0x1347a9,_0x595b67,_0x380e3a,_0xa66839,_0x3d1aa3,_0x4a0609){var _0x2681cf=genPersonInfoReq(_0x1347a9,_0x595b67,_0x380e3a,_0xa66839,_0x3d1aa3,_0x4a0609);return base64_encode(_0x2681cf);}function _0x581b(_0x34aceb,_0x142478){_0x34aceb=_0x34aceb-0x6b;var _0x412745=_0x4127[_0x34aceb];return _0x412745;}function setASN1(_0xc6c0a7,_0x171e90,_0x35e5f6,_0x386c1d){var _0x43180e=_0x581b,_0x238ad5=0x0,_0x5aa3b2,_0x5d8991=_0xc6c0a7['length'],_0x237b2d=new Array();_0x237b2d[_0x43180e(0x6c)](_0x171e90);_0x171e90==0x3&&_0x5d8991++;if(_0x5d8991<=0x7f)_0x237b2d[_0x43180e(0x6c)](_0x5d8991);else{var _0x238ad5=_0xc6c0a7[_0x43180e(0x6b)],_0x51c721='';do{_0x51c721+=String[_0x43180e(0x72)](_0x238ad5&0xff),_0x238ad5=_0x238ad5>>>0x8;}while(_0x238ad5>0x0);_0x237b2d['push'](_0x51c721[_0x43180e(0x6b)]|0x80);for(var _0x5aa3b2=_0x51c721[_0x43180e(0x6b)]-0x1;_0x5aa3b2>=0x0;--_0x5aa3b2){_0x237b2d['push'](_0x51c721['charCodeAt'](_0x5aa3b2));}}if(_0x171e90==0x3)_0x237b2d[_0x43180e(0x6c)](_0x35e5f6);return _0x237b2d=_0x237b2d['concat'](_0xc6c0a7),_0x237b2d;}function int2Bytes(_0x2298b7){var _0x4fabef=_0x581b,_0x19ddf1=new Array();if(_0x2298b7<=0x7f)_0x19ddf1[_0x4fabef(0x6c)](_0x2298b7);else{var _0x35fdb2=_0x2298b7,_0x2aa9bd='';do{_0x2aa9bd+=String[_0x4fabef(0x72)](_0x35fdb2&0xff),_0x35fdb2=_0x35fdb2>>>0x8;}while(_0x35fdb2>0x0);if(_0x2aa9bd['charCodeAt'](_0x2aa9bd[_0x4fabef(0x6b)]-0x1)&0x80)_0x19ddf1[_0x4fabef(0x6c)](0x0);for(var _0x5d69c2=_0x2aa9bd[_0x4fabef(0x6b)]-0x1;_0x5d69c2>=0x0;--_0x5d69c2){_0x19ddf1[_0x4fabef(0x6c)](_0x2aa9bd[_0x4fabef(0x70)](_0x5d69c2));}}return _0x19ddf1;}function getBytes(_0x2fca34){var _0xbe5c33=_0x581b,_0x1c131e=encode_utf8(_0x2fca34),_0x5242d1=new Array(_0x1c131e[_0xbe5c33(0x6b)]);for(var _0x473b95=0x0;_0x473b95<_0x1c131e[_0xbe5c33(0x6b)];_0x473b95++)_0x5242d1[_0x473b95]=_0x1c131e[_0xbe5c33(0x70)](_0x473b95);return _0x5242d1;}function encode_utf8(_0x4026a8){return unescape(encodeURIComponent(_0x4026a8));}function decode_utf8(_0x2d9917){return decodeURIComponent(escape(_0x2d9917));}function base64_encode(_0x36b44f){var _0x164983=_0x581b,_0x251c32='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',_0x1df0eb=0x0,_0x2f66ba=_0x36b44f[_0x164983(0x6b)],_0x4632e7,_0x32c593,_0x4c4fdd,_0x1a1732,_0x3e8a61,_0x47c5f3,_0x497212,_0x49289a=[];while(_0x1df0eb<_0x2f66ba){_0x4632e7=_0x36b44f[_0x1df0eb++],_0x32c593=_0x36b44f[_0x1df0eb++],_0x4c4fdd=_0x36b44f[_0x1df0eb++],_0x1a1732=_0x4632e7>>0x2,_0x3e8a61=(_0x4632e7&0x3)<<0x4|_0x32c593>>0x4,_0x47c5f3=(_0x32c593&0xf)<<0x2|_0x4c4fdd>>0x6,_0x497212=_0x4c4fdd&0x3f;if(isNaN(_0x32c593))_0x47c5f3=_0x497212=0x40;else isNaN(_0x4c4fdd)&&(_0x497212=0x40);_0x49289a[_0x164983(0x6c)](_0x1a1732,_0x3e8a61,_0x47c5f3,_0x497212);}return _0x49289a['map'](function(_0x3a89d6){var _0x684222=_0x164983;return _0x251c32[_0x684222(0x74)](_0x3a89d6);})[_0x164983(0x7c)]('');}function base64_decode(_0x137aa3){var _0x1edbdd=_0x581b,_0x33fe8a=_0x1edbdd(0x7a),_0x1d39ff,_0x16b500,_0x47f422,_0x11b435,_0x3d7ac6,_0x8bd6e7,_0x1070b8,_0x55cd58,_0x3a38ad=0x0,_0xa6237=0x0,_0x1637f5='',_0x35796b=[];if(!_0x137aa3)return _0x137aa3;_0x137aa3+='';do{_0x11b435=_0x33fe8a['indexOf'](_0x137aa3[_0x1edbdd(0x74)](_0x3a38ad++)),_0x3d7ac6=_0x33fe8a[_0x1edbdd(0x75)](_0x137aa3[_0x1edbdd(0x74)](_0x3a38ad++)),_0x8bd6e7=_0x33fe8a[_0x1edbdd(0x75)](_0x137aa3[_0x1edbdd(0x74)](_0x3a38ad++)),_0x1070b8=_0x33fe8a[_0x1edbdd(0x75)](_0x137aa3['charAt'](_0x3a38ad++)),_0x55cd58=_0x11b435<<0x12|_0x3d7ac6<<0xc|_0x8bd6e7<<0x6|_0x1070b8,_0x1d39ff=_0x55cd58>>0x10&0xff,_0x16b500=_0x55cd58>>0x8&0xff,_0x47f422=_0x55cd58&0xff;if(_0x8bd6e7==0x40)_0x35796b[_0xa6237++]=String[_0x1edbdd(0x72)](_0x1d39ff);else _0x1070b8==0x40?_0x35796b[_0xa6237++]=String[_0x1edbdd(0x72)](_0x1d39ff,_0x16b500):_0x35796b[_0xa6237++]=String[_0x1edbdd(0x72)](_0x1d39ff,_0x16b500,_0x47f422);}while(_0x3a38ad<_0x137aa3['length']);return _0x1637f5=_0x35796b['join'](''),_0x1637f5[_0x1edbdd(0x81)](/\0+$/,'');}
            //var moduleVersion	= { major : 1, minor : 3, build : 0, revision : 0 };			// Deremsecurity DS_UCPID_Client module version (*Do not modify)
            let moduleVersion	= { major : 2, minor : 1, build : 0, revision : 0 };		// [코스콤] 테스트 시 약속된 moduleVersion
            let moduleInfo		= { name  : "DS_UCPID_Client", vendorName : "Dreamsecurity" };	// Deremsecurity DS_UCPID_Client module information (*Do not modify)		
            let version			= [0x02];														// version 2
            let f_version		= setASN1(version, 0x02, 0);		
            let f_ucpidNonde	= setASN1(ucpidNonce, 0x04, 0);									// ucpidNonce
            let f_personInfoReq = genPersonInfoReq(ucpidAgreement, ucpidRealName, ucpidGender, ucpidNationalInfo, ucpidBirthDate, ucpidCi);	// personInfoReq
            let f_moduleInfo	= genModuleInfo(moduleInfo, moduleVersion);						// moduleInfo
            let f_ispUrlInfo	= setASN1(getBytes(ispUrlInfo), 0x0c, 0);						// ispUrlInfo
            let node			= f_version.concat(f_ucpidNonde);
            
            node = node.concat(f_personInfoReq);
            node = node.concat(f_moduleInfo);
            node = node.concat(f_ispUrlInfo);
            
            let seq  = setASN1(node, 0x30, 0);
            let msg  = base64_encode(seq);

            // 서명 원문으로 세팅
            ucpid.msg = msg;
            return ucpid;
        },
        /**
         * 전자서명을 MLAct로 postMessage를 사용하여 전달
         * @param {object} message 보낼 요청값
         * @param {function} mlCallback 응답 결과 처리할 함수
         */
        sendToChildPostMessage(message, mlCallback) {
            callback = mlCallback;
            this.addEventListener(callback)
            let iframeWindow = document.getElementById("dscert").contentWindow;
            iframeWindow.postMessage(message, targetOrigin);
        },
        // sessionStorage 관련 메서드 통합
        sessionStorage: {
            save(info) {
                sessionStorage.setItem(sessionKeyName, info);
            },
            load() {
                return sessionStorage.getItem(sessionKeyName);
            },
            clear() {
                sessionStorage.removeItem(sessionKeyName);
            }
        }
    }
})();
